

    require('../coord/single/singleCreator');
    require('./axis/SingleAxisView');
    require('../coord/single/AxisModel');
    require('./axisPointer');

    require('./axisPointer/SingleAxisPointer');

    var echarts = require('../echarts');

    echarts.extendComponentView({
        type: 'single'
    });




//////////////////
// WEBPACK FOOTER
// ./~/echarts/lib/component/singleAxis.js
// module id = 168
// module chunks = 1